export const tableProperties = [
  { prop: 'index', type: 'index', labelWidth: '50px', label: '序号' },
  { label: '模具编号', prop: 'mdin_no', itemType: 'input', input: true, sortable: false, widthAuto: true },
  { label: '模具名称', prop: 'mdin_name', itemType: 'input', input: true, sortable: false, widthAuto: true },
  { label: '客户简称', prop: 'cust_abbr', itemType: 'input', input: true, sortable: false, widthAuto: true }
];
